/** Human-readable labels for users/{uid}/tokenLedger source codes. */

export function describeLedgerSource(source) {
  switch (String(source || "")) {
    case "host.live_start":
      return "Live quiz — token spent";
    case "host.live_refund_under_limit":
      return "Live quiz — automatic refund (under 5 questions)";
    case "stripe.invoice.paid":
      return "Weekly subscription credit";
    case "stripe.checkout.oneoff":
      return "One-off token purchase";
    case "dev.seed":
      return "Test token seed";
    default:
      return source ? String(source) : "Token change";
  }
}

export function formatLedgerQuantity(quantity) {
  const n = Number(quantity) || 0;
  if (n > 0) return `+${n}`;
  return String(n);
}
